import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { PartnerProductInsightsAPIPartner } from './types/PartnerProductInsightsAPIPartner';

export const PARTNER_INSIGHTS_API_PATH = `${PUBLIC_API_BASE_PATH}partner-insights`;

// Without a timeout fetchJSONWithTimeout skips the abort entirely. This route
// runs on our own pods, whose upstream call is itself bounded at 750ms, so
// 5000ms leaves room for a healthy round trip while stopping the browser
// holding a connection open against a saturated pod.
const CLIENT_TIMEOUT_MS = 5000;

export const fetchPartnerInsightsClient = async (
  shortcode: string,
): Promise<PartnerProductInsightsAPIPartner | null> => {
  const response = await fetchJSONWithTimeout(
    `${PARTNER_INSIGHTS_API_PATH}/${encodeURIComponent(shortcode)}`,
    { timeout: CLIENT_TIMEOUT_MS },
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};
